import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 上传文件
export function upload(param, config) {
  return request.post(apiConfig.document.api.upload.url, param, config);
}
